import { FC } from "react";
import { Button } from "../../atoms/Button";
import { ButtonWrapper, Wrapper, Text } from "./elements";
import { Props } from "./types";

const PermanentlyDeleteModalBody: FC<Props> = ({
  onConfirm,
  onCancel,
  isLoading,
}) => {
  return (
    <>
      <Wrapper>
        <Text>
          Are you sure you want to delete this file? You won't able
          to recover it once deleted.
        </Text>
        <ButtonWrapper>
          <Button type={"primary"} id="cancel_btn" onClick={onCancel}>
            Cancel
          </Button>
          <Button type={"primary"} id="confirm_btn" onClick={onConfirm} loading={isLoading}>
            Delete
          </Button>
        </ButtonWrapper>
      </Wrapper>
    </>
  );
};

export default PermanentlyDeleteModalBody;
